import { DataExplorerQueryParams } from './data-explorer-data-points';

function createDataExplorerSearchParams(queryParams: DataExplorerQueryParams): URLSearchParams {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (!value) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, String(item)));
      return;
    }
    params.append(key, String(value));
  });

  return params;
}

export function buildDataExplorerLink(basePath: string, queryParams: DataExplorerQueryParams): string {
  return `${basePath}?${createDataExplorerSearchParams(queryParams).toString()}`;
}
